import type { GroupOption } from 'v5/core/entity-schema/entitySchema.types';
import type { FieldComponent } from './fieldComponent.types';
import {
  MultiSelectRenderValue,
  OptionRefMultiSelect,
  type OptionRefMultiSelectProps
} from './OptionRefMultiSelect';

export type { MultiSelectRenderValue };

/** Feature-provided renderers for selected badges and dropdown rows (colour, icon…). */
export type GroupsFieldConfig = Pick<
  OptionRefMultiSelectProps<GroupOption>,
  'renderSelectedValue' | 'renderOption'
>;

/** Groups multi-select over `OptionRef[]`; always creatable. */
export function createGroupsField(
  config: GroupsFieldConfig
): FieldComponent<'groups'> {
  return function GroupsField({ spec, path, hideLabel }) {
    return (
      <OptionRefMultiSelect
        spec={spec}
        path={path}
        hideLabel={hideLabel}
        placeholder="Select groups"
        create={{ label: 'Create new group' }}
        renderSelectedValue={config.renderSelectedValue}
        renderOption={config.renderOption}
      />
    );
  };
}
